module.exports = __webpack_public_path__ + "img/1@3x.047ec5b8.png";